import React, { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import PasswordPopup from "./PasswordPopup";

const AdminLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [showPopup, setShowPopup] = useState(false);
  const [popupFor, setPopupFor] = useState("");

  const PASSWORDS = {
    Projects: "Lcepl@2026",
    Gallery: "Lcepl#2026",
    CSR: "Lcepl$2026",
    Policies: "Lcepl%2026",
    HR: "Lcepl^2026",
  };

  const menuItems = [
    { name: "Projects", path: "/admin/projects" },
    { name: "Gallery", path: "/admin/gallery" },
    { name: "CSR", path: "/admin/csr" },
    { name: "Policies", path: "/admin/policies" },
    { name: "HR", path: "/admin/hr" },
  ];

  // const handleMenuClick = (item) => {
  //   if (item.name === "Projects" || item.name === "Gallery") {
  //     setPopupFor(item.name);
  //     setShowPopup(true);
  //   } else {
  //     navigate(item.path);
  //   }
  // };
  const handleMenuClick = (item) => {
    if (Object.prototype.hasOwnProperty.call(PASSWORDS, item.name)) {
      setPopupFor(item.name);
      setShowPopup(true);
    } else {
      navigate(item.path);
    }
  };  

  const handlePasswordSubmit = (password) => {
    if (password === PASSWORDS[popupFor]) {
      setShowPopup(false);
      navigate(`/admin/${popupFor.toLowerCase()}`);
    } else {
      alert("❌ Incorrect password");
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem("admin");
    navigate("/admin-login");
  };

  return (
    <div className="flex min-h-screen">

      {/* Sidebar */}
      <div className="w-64 bg-gray-800 text-white flex flex-col">
        <div className="text-2xl font-bold p-4 border-b border-gray-700">
          Admin Panel
        </div>
        <nav className="flex-1 p-4">
          {menuItems.map((item) => (
            <button
              key={item.name}
              onClick={() => handleMenuClick(item)}
              className={`w-full text-left px-4 py-2 rounded mb-2 hover:bg-gray-700 transition-colors ${
                location.pathname === item.path ? "bg-gray-700 font-semibold" : ""
              }`}
            >
              {item.name}
            </button>
          ))}
        </nav>

        {/* ── Logout moved to bottom of sidebar — no more overlap ── */}
        <div className="p-4 border-t border-gray-700">
          <button
            onClick={handleLogout}
            className="w-full bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded text-sm font-medium transition"
          >
            Logout
          </button>
        </div>
      </div>

      {/* Main Content — no longer needs padding for floating button */}
      <div className="flex-1 bg-gray-100 p-4">
        <Outlet />
      </div>

      {/* Password Popup */}
      {showPopup && (
        <PasswordPopup
          title={`${popupFor} Access`}
          onSubmit={handlePasswordSubmit}
          onClose={() => setShowPopup(false)}
        />
      )}
    </div>
  );
};

export default AdminLayout;